import React, { useState } from 'react';
import Container from 'container';
import Icon from 'icon';
import Button from 'button';
import 'swiper/dist/css/swiper.css';
import { debouncedNavigation } from '../../../utility';
import MenuSlide from './menu-slide';
import HighSlide from './high-slide';
import Bong from '../bong';
import s from './crazy-swiper.module.scss';

const stages = [
  'START',
  '420',
  'SEED',
  'GROW',
  'HARVEST',
  'SMOKE',
  'TERPENES',
  'INDICA',
  'SATIVA',
  'RITUAL'
];

const highSlides = [
  {
    images: ['4021', '4022']
  },
  {
    images: ['seed-1', 'seed-2']
  },
  {
    images: ['grow1', 'grow2', 'grow3']
  },
  {
    images: ['harvest-1', 'harvest-2', 'harvest-3', 'harvest-4']
  },
  {
    images: ['smoke-1', 'smoke-2']
  },
  {
    images: ['terpenes-1', 'terpenes-2']
  },
  {
    images: ['indica-1a', 'indica-2']
  },
  {
    images: ['sativa-1', 'sativa-2']
  }
];

export default function CrazySwiper({ hash, setModalOn, stage, setStage, browser: isSafari }) {
  const [scrollable, setScrollable] = useState(true);
  const [bongPosition, setBongPosition] = useState(0);
  const [touchStart, setTouchStart] = useState(0);

  const gotoContact = () => {
    debouncedNavigation('#contact');
  };

  const goNext = () => {
    if (window.highSwiper !== null) {
      if (stage !== 9) {
        window.highSwiper.slideNext();
        setStage(stage + 1);
      } else {
        gotoContact();
      }
    }
  };

  const goPrev = () => {
    if (window.highSwiper !== null) {
      window.highSwiper.slidePrev();
      if (stage > 0) {
        setStage(stage - 1);
      } else {
        debouncedNavigation('#welcome');
        const videoPlayer = document.querySelector('video');
        videoPlayer && videoPlayer.play();
      }
    }
  };

  const wheelEventHandler = event => {
    if (scrollable && stage !== 9) {
      setScrollable(false);
      const direction =
        event.deltaY < -100 ? 'up' : event.deltaY > 100 ? 'down' : null;
      console.log(event.deltaY, 'event.deltaY');
      if (direction === 'up') {
        debouncedNavigation('#welcome');
        const videoPlayer = document.querySelector('video');
        videoPlayer && videoPlayer.play();
      }
      if (direction === 'down') {
        debouncedNavigation('#contact');
      }
      setTimeout(() => {
        setScrollable(true);
      }, 1500);
    } else {
      if (stage === 9) {
        const direction =
          event.deltaY < -50 ? 'up' : event.deltaY > 50 ? 'down' : null;
        if (direction === 'up') {
          debouncedNavigation('#welcome');
        }
        if (direction === 'down') {
          debouncedNavigation('#contact');
        }
      }
    }
  };

  const handleTouchUp = event => {
    const position = event.changedTouches[0].clientY;
    if (scrollable && stage !== 9) {
      setScrollable(false);
      const direction = touchStart.clientY - position < 0 ? 'up' : 'down';
      if (direction === 'up') {
        debouncedNavigation('#welcome');
        const videoPlayer = document.querySelector('video');
        videoPlayer && videoPlayer.play();
      }
      if (direction === 'down') {
        debouncedNavigation('#contact');
      }
      setTimeout(() => {
        setScrollable(true);
      }, 700);
    } else {
      if (stage === 9) {
        const direction = touchStart.clientY - position < 0 ? 'up' : 'down';
        if (direction === 'up') {
          debouncedNavigation('#welcome');
        }
        if (direction === 'down') {
          debouncedNavigation('#contact');
        }
      }
    }
  };

  const handleTouchStart = event => {
    setTouchStart(event.changedTouches[0]);
  };

  return (
    <Container
      className={`${s.root} ${isSafari ? s.safari: ''}`}
      onWheel={wheelEventHandler}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchUp}
    >
      <div className={`swiper-container swiper-slide ${s.slide}`}>
        <div className="swiper-wrapper">
          <div className={`swiper-slide ${s.slide}`}>
            {stage === 0 && <MenuSlide
              {...{ stages, setStage, isSafari }}
              gotoContact={() => {
                gotoContact();
              }}
            />}
          </div>
          {highSlides.map(({ images }, i) => (
            <div
              className={`swiper-slide ${s.slide}`}
              key={`swiper-${images[0]}-${i}`}
            >
              <HighSlide
                stage={stage}
                index={i}
                images={images}
                stageName={stages[i + 1]}
              />
            </div>
          ))}
          <div className={`swiper-slide ${s.slide}`}>
            <Bong
              {...{
                handleScrollEvent: wheelEventHandler,
                bongPosition,
                setBongPosition,
                stage,
                handleTouchUp
              }}
            />
          </div>
        </div>
        <div className="swiper-pagination" />
      </div>
      {stage !== 9 && (
        <button
          className={`${s.sliderNext} ${stage !== 0 ? s.white : ''}`}
          onClick={goNext}
        >
          {stage === 0 ? 'START' : stages[stage + 1]}
          <Icon icon="chevron-double-right" className={s.arrowNext} />
        </button>
      )}
      {stage !== 0 && (
        <>
          <button
            className={`${s.sliderPrev} ${stage !== 0 ? s.white : ''}`}
            onClick={goPrev}
          >
            <Icon icon="chevron-double-left" className={s.arrowPrev} />
            {stage === 1 ? 'MENU' : stages[stage > 0 ? stage - 1 : '']}
          </button>
          <div className={`${s.buttons} ${isSafari ? s.safari : ''}`}>
            <Button
              invert
              bold
              className={s.btn1}
              onClick={() => {
                debouncedNavigation('#contact');
                const videoPlayer = document.querySelector('video');
                videoPlayer && videoPlayer.pause();
              }}
            >
              LOCATION
            </Button>
            {/* <Button bold className={s.btn2} onClick={setModalOn}>
              BUY TICKETS
            </Button> */}
          </div>
        </>
      )}
    </Container>
  );
}
